const iconStyle = {
  fontSize: '24px',
  paddingTop: '4px',
}

export const plusIconStyle = {
  ...iconStyle,
}

export const minusIconStyle = {
  ...iconStyle,
}

export const arrowIconStyle = (disabled: boolean) => {
  return {
    fontSize: '16px',
    color: disabled ? 'grey' : 'black',
    opacity: disabled ? '50%' : '100%',
  }
}
